module.exports = __webpack_public_path__ + "img/menu-5.be0d6481.svg";